import type { GalleryGoalOption } from "./galleryGoals";

// The four goals the signed collector design lists (App Onboarding.dc.html, `GOALS.collector`), in
// that order. Values are SignupIntent flags, so a selection is the same bitmask the registration
// POST has always carried. `analyticsLabel` carries the same weight it does in galleryGoals.ts (see
// that file's GalleryGoalOption doc): it is the word `Intent.displayType()` puts in
// page/Onboarding.jsx's `'OB: Intent Declared'` payload, not the chip's own copy - both wizards
// feed the same ACA-95 funnel.
//
// No ordinal for User.Type travels with this table. Unlike the artist, the Collector's type is not
// decided server-side: it registers via POST /register with an explicit Type, the same way the
// gallery does, because that is what the Collector's legacy flow does. That value reaches the
// container by prop (collectorUserTypeValue), not from here.
//
// `Catalogue` (256) is reused on purpose, not duplicated by accident, the same way ARTIST_GOALS
// reuses `Consignments` (128). "Catalogue my works" (artist) and "Catalogue my collection"
// (collector) are the same act over different holdings, so the two lists sharing this one bit is a
// decision, not an automatism.
export const COLLECTOR_GOALS: readonly GalleryGoalOption[] = [
  { value: 256, label: "Catalogue my collection", analyticsLabel: "Catalogue" }, // Catalogue (reused, see above)
  { value: 1024, label: "Track valuations", analyticsLabel: "Valuations" }, // Valuations
  { value: 2048, label: "Manage provenance", analyticsLabel: "Provenance" }, // Provenance
  { value: 4096, label: "Plan acquisitions", analyticsLabel: "Acquisitions" }, // Acquisitions
] as const;
